import { render, staticRenderFns } from "./code-box.vue?vue&type=template&id=391ceaca&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./code-box.vue?vue&type=script&lang=ts&"
export * from "./code-box.vue?vue&type=script&lang=ts&"
import style0 from "./code-box.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports